import { useState } from 'react';

/**
 * Hook for managing state of form values.
 * Make sure that each input has a name prop with the value corresponding to the correct default
 *
 * @example
 * const [values, updateValues] = useForm({
 *   name: '',
 *   email: '',
 *   mapleSyrup: '',
 * });
 *
 * <input
 *   type="text"
 *   name="name"
 *   id="name"
 *   value={values.name}
 *   onChange={updateValues}
 * />
 *
 * @param defaults an object with default values
 * @returns [values, updateValue, resetToDefaultValues]: values are current values. updateValue is given an event an updates the state value. resetDefaulValues sets the values back to the defaults that were passed in originally.
 */
export default function useForm<T>(
  defaults: T
): [T, (e: any) => void, () => void] {
  const [values, setValues] = useState<T>(defaults);

  function updateValue(e) {
    // check if a number and convert
    let { value } = e.target;
    if (e.target.type === 'number') {
      value = parseInt(value);
    }

    setValues({
      ...values,
      [e.target.name]: value,
    });
  }

  function resetToDefaultValues() {
    setValues(defaults);
  }

  return [values, updateValue, resetToDefaultValues];
}
